<div class="web-view">
    <img src="../../../../assets/img/race-to-gold/race-to-gold-web.jpg" class="w-100" onContextMenu="return false;">
</div>
<div class="mobile-view">
  <a onclick="history.back()"
  class="btn back"><i class="bx bx-chevron-left" style="color: #fff; font-size: 1.6em;"></i> Back</a>
  <div class="mobile_version-backbutton"> 
  </div>

    <img src="../../../../assets/img/race-to-gold/race-to-gold mobile.jpg" class="w-100" onContextMenu="return false;">
</div>
<script>
    $('img').mousedown(function (e) {
  if(e.button == 2) { // right click
    return false; // do nothing!
  }
});
</script>